var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayStore = function SvgPlayStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1017.9 1110.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m174.9 1082.5 619.5-349.7-132.7-130.4zm619.5-704.6L174.9 28.2l486.8 480.1zm191.4 111.5-129.9-73.9-145 139.9 145 139.9 132.6-74c39.7-31 39.7-100.9-2.7-131.9M47.8 0C19.2 14.8 0 41.6 0 76.6v957.3c0 34.9 19.2 61.8 47.8 76.6l566.1-555.3z"
  })));
};
export default SvgPlayStore;